import type { LovDrDTO } from '@/features/api/extranet/dto/Demande/DR'
import type { DemandeStore } from '@/features/interface/demande/shared'
import { buildDemandeActions } from '@/features/interface/demande/shared'
import { computed, type InjectionKey } from 'vue'
import { storeToRefs } from 'pinia'

type DemandeCXPIActions = ReturnType<typeof useDRActions>
export const DR_ACTIONS: InjectionKey<DemandeCXPIActions> = Symbol('cxpi-actions')

export function useDRActions(store: DemandeStore<'MODEL_DR', LovDrDTO>) {
  const { model } = storeToRefs(store)
  // const eventBus = useEventBus()

  // typeDocumentTemplate: computed(() => null),
  const actionsDemande = buildDemandeActions(store)

  const estDemandeDR = computed(() => {
    return !model.value?.code
  })

  return {
    ...actionsDemande,
    estDemandeDR
  }
}
